export default {
  nodeConfig: {
    common: {
      placeholder: '请输入',
      selectPlaceholder: '请选择',
      noData: '暂无数据',
      noMatch: '无匹配',
      searchNode: '搜索节点',
      remove: '删除',
      oneClickDeploy: '一键部署',
      externalConfiguration: '外部配置',
      managed: '内置',
      external: '外部',
    },
    panel: {
      unnamedNode: '未命名节点',
      namePlaceholder: '请输入节点名称',
      noDescription: '暂无描述',
      descPlaceholder: '请输入节点描述',
      applyTemplate: '应用模板',
      operationGuide: '操作指南',
      loading: '加载中...',
      templateNamePlaceholder: '请输入模板名',
      saveTemplate: '保存模板',
      cancel: '取消',
      save: '保存',
      message: {
        checkForm: '请检查表单验证',
        saveTemplateSuccess: '保存模板成功',
        saveTemplateFailed: '保存模板失败',
      },
      inputVars: '输入变量',
      outputVars: '输出变量',
    },
    nodeSelector: {
      basicNodes: '基础节点',
      buildInTools: '内置工具',
      searchNode: '搜索节点',
      searchTool: '搜索工具',
      searchPlaceholder: '搜索节点、插件、工作流',
      noSearchResults: '无搜索结果',
      noAvailableNodes: '暂无可用节点',
      nodeComingSoon: '该节点即将上线，敬请期待',
      groups: {
        'ai_knowledge': '',
        'start': '开始',
        'logic': '逻辑',
        'code': '代码',
        'output': '输出',
        'utilities': '工具',
        'dedicated_database': '专用数据库',
        'cloud_storage': '云存储',
        'messages': '消息',
        'search': '搜索',
        'nlp_pipeline': 'NLP 管道',
        'image': '图像',
        'audio': '音频',
        'video': '视频',
        '3d': '3D',
        'content_safe': '内容安全',
      },
    },
    varSelect: {
      inputPlaceholder: '请输入',
      inputTagPlaceholder: '请输入，按Enter键添加',
      cascaderPlaceholder: '请选择前置节点变量',
      varUndefined: '变量未定义',
      switchTip: '可切换使用变量或者直接输入',
    },
    validation: {
      predecessorVarUndefined: '前置节点变量未定义',
      modelNameRequired: '模型名称不能为空',
      promptRequired: '用户提示词不能为空',
      modelRequired: '分词模型不能为空',
      modeRequired: '分词模式不能为空',
      contentVarRequired: '待检测文本不能为空',
      codeRequired: '代码不能为空',
      javascriptCodeRequired: 'JavaScript代码不能为空',
      pythonCodeRequired: 'Python代码不能为空',
      operationRequired: '操作类型不能为空',
      databaseRequired: '数据库不能为空',
      connectionRequired: '连接配置不能为空',
      databaseConnectionRequired: '数据库连接配置不能为空',
      redisConnectionRequired: 'Redis连接配置不能为空',
      loopTypeRequired: '循环类型不能为空',
      entryNodesRequired: '至少需要配置一个入口节点',
      subWorkflowRequired: '子工作流不能为空',
      tokenModeRequired: 'Token操作模式不能为空',
      knowledgeIdRequired: '知识库ID不能为空',
      itemsRequired: '至少需要配置一个检索项',
    },
    varTable: {
      outputType: '输出类型',
      noVars: '暂无变量',
      typeText: '文本',
      typeMarkdown: 'Markdown',
      typeJson: 'JSON',
      addVar: '添加变量',
    },
    varRecursive: {
      varName: '变量名',
      varNamePlaceholder: '请输入变量名',
      type: '类型',
      addChild: '添加子变量',
      delete: '删除',
      varValue: '变量值',
      varValuePlaceholder: '请输入变量值',
      copySuccess: '变量名已复制到剪贴板',
      copyFailed: '复制失败，请手动复制',
    },
    varType: {
      placeholder: '变量类型',
      string: '字符串',
      number: '数字',
      boolean: '布尔值',
      time: '时间',
      array: '数组',
      object: '对象',
    },
    exceptionHandle: {
      header: '异常处理',
      maxRetries: '最大重试次数',
      maxRetriesTooltip: '0表示不重试，最大重试次数为5',
      retryDelay: '重试间隔',
      retryDelayTooltip: '默认0，单位秒',
      unitSecond: '秒',
      timeout: '超时时间',
      timeoutTooltip: '超时区间0.1-600s',
      retryType: '异常判定',
      retryTypeTooltip:
        '默认：超时或系统异常；自定义异常：在超时和系统异常的基础上，支持用自定义代码判断输出变量是否符合要求',
      retryTypeDefault: '默认',
      retryTypeCustom: '自定义',
      customRetryCode: '自定义异常判定代码',
    },
    llm: {
      header: '模型配置',
      modelPlaceholder: '请选择模型',
      paramsHeader: '模型参数配置',
      temperature: '温度',
      maxTokens: '最大令牌数',
      topP: 'Top P',
      topK: 'Top K',
      streaming: '流式生成',
      thinking: '是否启用思考',
      jsonFormat: '是否JSON格式化',
      strictMode: '严格模式',
    },
    connection: {
      header: '连接配置',
      tooltip: '支持连接外部源，非必填',
      host: '主机',
      hostPlaceholder: '请输入主机IP或域名',
      port: '端口',
      portPlaceholder: '请输入端口',
      username: '用户名',
      usernamePlaceholder: '请输入用户名',
      password: '密码',
      passwordPlaceholder: '请输入密码',
    },
    condition: {
      and: '且 (AND)',
      or: '或 (OR)',
      addCondition: '添加条件',
      maxDepthReached: '已达到最大嵌套层级({depth}层)',
      addChildGroup: '添加子组',
      deleteGroup: '删除组',
      delete: '删除',
      emptyExpression: '(空表达式)',
    },
    sql: {
      simpleMode: '简单模式',
      advancedMode: '高级模式',
      selectFields: '选择字段',
      allFields: '所有字段 (*)',
      orderBy: '排序',
      asc: '升序',
      desc: '降序',
      delete: '删除',
      addSort: '添加排序',
      groupBy: '分组',
      groupByPlaceholder: '选择分组字段（可选）',
      countField: '计数字段',
      countAll: '全部 (*)',
      countDistinct: '去重计数 (DISTINCT)',
      sqlTemplate: 'SQL 模板',
      templatePlaceholder: '选择常用模板（可选）',
      addColumn: '添加列',
      dropColumn: '删除列',
      createIndex: '创建索引',
      dropIndex: '删除索引',
      truncate: '清空表',
      sqlStatement: 'SQL 语句',
      sqlPlaceholderSimple: '请输入 SQL 语句或从模板中选择',
      sqlPlaceholderAdvanced:
        '请输入需要执行的SQL 查询语句，通过插入{变量名}可以引用输入参数。\n例：\nselect * from table_name\nwhere name = {name}',
      generatedSql: '生成的 SQL：',
      copy: '复制',
      empty: '(空)',
      configureHint: '(请配置查询条件)',
      quickInsert: '快捷插入：',
    },

    data: {
      documentExtractor: {
        sourceType: '来源类型',
        sourceTypePlaceholder: '选择文档来源',
        sources: {
          file: '本地文件',
          url: 'URL地址',
          base64: 'Base64数据',
        },
        docType: '文档类型',
        docTypePlaceholder: '选择文档类型',
        docTypes: {
          auto: '自动识别',
          pdf: 'PDF',
          docx: 'Word (docx)',
          xlsx: 'Excel (xlsx)',
          txt: '文本文件',
          html: 'HTML',
          image: '图片',
          json: 'JSON',
          csv: 'CSV',
        },
        uploadFile: '上传文件',
        selectFile: '选择文件',
        filePath: '文件路径',
        filePathPlaceholder: '输入服务器上的文件路径',
        filePathFromVar: '从变量获取路径',
        filePathVarPlaceholder: '选择包含文件路径的变量',
        urlAddress: 'URL地址',
        urlPlaceholder: '输入URL地址',
        inputVar: '输入变量',
        inputVarPlaceholder: '选择包含Base64数据的变量',
        configHeader: '文档来源配置',
        extractHeader: '提取配置',
        encoding: '编码格式',
        encodingPlaceholder: '选择编码格式',
        maxPages: '最大页数',
        noLimit: '0表示不限制',
        timeout: '超时时间(秒)',
        extractMetadata: '提取元数据',
        extractImages: '提取图片',
        ocrHeader: 'OCR配置',
        enableOcr: '启用OCR',
        ocrProvider: 'OCR服务商',
        ocrProviderPlaceholder: '选择OCR服务商',
        apiKey: 'API Key',
        apiKeyPlaceholder: '输入API Key',
        secretKey: 'Secret Key',
        secretKeyPlaceholder: '输入Secret Key',
      },
      listOperator: {
        inputConfig: '输入配置',
        inputVar: '输入变量',
        inputVarPlaceholder: '选择要操作的列表变量',
        operationConfig: '操作配置',
        operationType: '操作类型',
        operationTypePlaceholder: '选择操作类型',
        operations: {
          filter: '过滤 (filter)',
          sort: '排序 (sort)',
          unique: '去重 (unique)',
          slice: '切片 (slice)',
          reverse: '反转 (reverse)',
          map: '映射 (map)',
          flatten: '展平 (flatten)',
          group_by: '分组 (group_by)',
          chunk: '分块 (chunk)',
          count: '计数 (count)',
          sum: '求和 (sum)',
          avg: '平均值 (avg)',
          min: '最小值 (min)',
          max: '最大值 (max)',
          first: '第一个 (first)',
          last: '最后一个 (last)',
          find: '查找 (find)',
          find_index: '查找索引 (find_index)',
          every: '全部满足 (every)',
          some: '存在满足 (some)',
          concat: '合并 (concat)',
          difference: '差集 (difference)',
          intersect: '交集 (intersect)',
          union: '并集 (union)',
        },
        operationField: '操作字段',
        fieldPlaceholder: '输入字段名',
        secondList: '第二个列表',
        secondListPlaceholder: '选择第二个列表变量',
        groupField: '分组字段',
        groupFieldPlaceholder: '输入分组字段名',
        filterCondition: '过滤条件',
        fieldName: '字段名',
        operators: {
          equals: '等于',
          not_equals: '不等于',
          gt: '大于',
          gte: '大于等于',
          lt: '小于',
          lte: '小于等于',
          contains: '包含',
          starts_with: '开头是',
          ends_with: '结尾是',
          is_empty: '为空',
          regex: '正则匹配',
        },
        value: '值',
        addCondition: '添加条件',
        sortConfig: '排序配置',
        sortField: '排序字段',
        orders: {
          asc: '升序',
          desc: '降序',
        },
        addSortField: '添加排序字段',
        sliceConfig: '切片配置',
        sliceStart: '起始索引',
        sliceEnd: '结束索引',
        sliceStep: '步长',
        chunkConfig: '分块配置',
        chunkSize: '块大小',
      },
      set: {
        varSet: '变量设置',
        setMode: '设置模式',
        modes: {
          set: '覆盖 (set)',
          merge: '合并 (merge)',
        },
        colName: '变量名',
        colValueType: '值类型',
        colValue: '值',
        colType: '类型',
        valueTypes: {
          static: '静态值',
          variable: '变量引用',
          expression: '表达式',
        },
        placeholderName: '变量名',
        placeholderVar: '选择变量',
        placeholderExp: '输入表达式',
        placeholderValue: '输入值',
        placeholderType: '类型',
        addVar: '添加变量',
      },
      template: {
        configHeader: '模板配置',
        engine: '模板引擎',
        enginePlaceholder: '选择模板引擎',
        engines: {
          simple: '简单替换',
          go: 'Go模板',
          jinja2: 'Jinja2',
          handlebars: 'Handlebars',
        },
        content: '模板内容',
        contentPlaceholder: '输入模板内容',
        // eslint-disable-next-line no-template-curly-in-string
        templatePlaceholder: '例如：你好，${name}！',
        syntaxLabel: '支持语法：',
        // eslint-disable-next-line no-template-curly-in-string
        notSupportVarSyntax: '不支持 ${var} 语法',
        outputFormat: '输出格式',
        formats: {
          string: '字符串',
          json: 'JSON',
          html: 'HTML',
        },
        escapeHtml: '转义HTML',
        strictMode: '严格模式',
        strictModeTip: '启用后，变量不存在时会报错',
        varMapping: '变量映射',
        colName: '变量名',
        colSource: '值来源',
        placeholderName: '变量名',
        placeholderSource: '选择变量',
        addVar: '添加变量',
        syntaxHelp: '模板语法帮助',
        helpSimple: {
          title: '简单替换语法:',
          desc: '替换为变量值',
        },
        helpGo: {
          title: 'Go模板语法:',
          output: '输出变量值',
          condition: '条件判断',
          loop: '循环',
          filter: '使用过滤器',
        },
        helpJinja2: {
          title: 'Jinja2语法:',
          output: '输出变量值',
          condition: '条件判断',
          loop: '循环',
          filter: '使用过滤器',
        },
        helpHandlebars: {
          title: 'Handlebars语法:',
          output: '输出变量值',
          condition: '条件判断',
          loop: '循环',
        },
      },
      transform: {
        inputConfig: '输入配置',
        inputVar: '输入变量',
        inputVarPlaceholder: '选择要转换的变量',
        staticInput: '静态输入',
        staticInputPlaceholder: '或输入静态值',
        transformConfig: '转换配置',
        transformType: '转换类型',
        transformTypePlaceholder: '选择转换类型',
        types: {
          base64_encode: 'Base64编码',
          base64_decode: 'Base64解码',
          url_encode: 'URL编码',
          url_decode: 'URL解码',
          html_encode: 'HTML实体编码',
          html_decode: 'HTML实体解码',
          hex_encode: '十六进制编码',
          hex_decode: '十六进制解码',
          json_parse: 'JSON解析',
          json_stringify: 'JSON序列化',
          xml_to_json: 'XML转JSON',
          json_to_xml: 'JSON转XML',
          html_to_text: 'HTML转文本',
          markdown_to_html: 'Markdown转HTML',
          md5: 'MD5',
          sha1: 'SHA1',
          sha256: 'SHA256',
          sha512: 'SHA512',
          aes_encrypt: 'AES加密',
          aes_decrypt: 'AES解密',
          uppercase: '转大写',
          lowercase: '转小写',
          trim: '去除空白',
          replace: '字符串替换',
          regex_replace: '正则替换',
          split: '分割为数组',
          join: '数组连接',
          substring: '子字符串',
          pad_start: '左侧填充',
          pad_end: '右侧填充',
          jsonpath: 'JSONPath提取',
          regex_match: '正则匹配',
          regex_extract: '正则提取',
          gzip_compress: 'Gzip压缩',
          gzip_decompress: 'Gzip解压',
        },
        find: '查找',
        findPlaceholder: '要查找的字符串或正则表达式',
        replaceWith: '替换为',
        replaceWithPlaceholder: '替换后的字符串',
        separator: '分隔符',
        separatorPlaceholder: '输入分隔符',
        start: '起始位置',
        end: '结束位置',
        length: '目标长度',
        padChar: '填充字符',
        padCharPlaceholder: '默认为空格',
        aesKey: '加密密钥',
        keyPlaceholder: '16/24/32位密钥',
        jsonPath: 'JSONPath表达式',
        jsonPathPlaceholder: '如: $.data.items[0].name',
        regex: '正则表达式',
        regexPlaceholder: '输入正则表达式',
        groupIndex: '分组索引',
        outputFormat: '输出格式',
        formats: {
          string: '字符串',
          bytes: '字节',
          base64: 'Base64',
        },
      },
    },
    ai: {
      llm: {
        promptVars: '提示词变量',
        promptConfig: '提示词配置',
        systemPrompt: '系统提示词（SYSTEM）',
        systemPromptPlaceholder: '请输入系统提示词，用于设定AI的角色和行为规则',
        userPrompt: '用户提示词（USER）',
        userPromptPlaceholder: '请输入用户提示词，描述具体的任务和要求',
        outputVars: '输出变量',
      },
      embedding: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择嵌入模型配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        basicHeader: '基础配置',
        provider: '服务提供商',
        providerPlaceholder: '请选择服务提供商',
        aliyun: '阿里云通义',
        baidu: '百度文心',
        tencent: '腾讯混元',
        custom: '自定义HTTP服务',
        model: '模型',
        modelPlaceholder: '请选择模型',
        customModelPlaceholder: '请输入自定义模型名称',
        batchSize: '批处理大小',
        timeout: '超时时间(秒)',
        apiHeader: 'API配置',
        apiKeyPlaceholder: '请输入API密钥（可选，优先使用全局配置）',
        secretKeyPlaceholder: '请输入Secret Key',
        endpointPlaceholder: '请输入API端点URL',
        region: '区域',
        regionPlaceholder: '请输入服务区域',
        inputVars: '输入变量',
        outputVars: '输出变量',
      },
      intent: {
        promptVars: '提示词变量',
        promptConfig: '提示词配置',
        systemPrompt: '系统提示词',
        systemPromptPlaceholder: '请输入系统提示词',
        userPrompt: '用户提示词',
        userPromptPlaceholder: '请输入用户提示词',
        intentDefinition: '意图定义',
        intentItem: '意图',
        name: '名称',
        namePlaceholder: '意图名称',
        description: '描述',
        descriptionPlaceholder: '意图描述',
        exampleQuery: '示例语句',
        addExample: '添加示例',
        addIntent: '添加意图',
        outputVars: '输出变量',
      },
      stt: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择语音识别配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        basicHeader: '基础配置',
        provider: '服务提供商',
        openai: 'OpenAI Whisper',
        aliyun: '阿里云语音识别',
        azure: 'Azure语音服务',
        tencent: '腾讯云语音识别',
        volcengine: '火山引擎语音识别',
        google: 'Google Cloud Speech',
        model: '模型',
        modelPlaceholder: '请选择模型',
        audioSource: '音频来源',
        audioSourcePlaceholder: '请选择音频来源',
        url: 'URL地址',
        base64: 'Base64编码',
        file: '本地文件',
        variable: '变量',
        audioVar: '音频变量',
        audioVarPlaceholder: '选择前置节点的输出变量',
        filePath: '文件路径',
        filePathPlaceholder: '请输入音频文件的本地路径',
        language: '识别语言',
        languagePlaceholder: '请选择识别语言',
        autoDetect: '自动检测',
        zh: '中文',
        en: '英文',
        ja: '日语',
        ko: '韩语',
        es: '西班牙语',
        fr: '法语',
        de: '德语',
        ru: '俄语',
        prompt: '提示词',
        promptPlaceholder: '可选，输入特定词汇帮助提高识别准确度',
        hotWords: '热词列表',
        hotWordsPlaceholder: '输入并按回车添加热词',
        responseFormat: '输出格式',
        responseFormatPlaceholder: '请选择输出格式',
        text: '纯文本',
        json: 'JSON格式',
        verboseJson: '详细JSON（含时间戳）',
        srt: 'SRT字幕格式',
        vtt: 'VTT字幕格式',
        advancedHeader: '高级选项',
        enablePunctuation: '启用标点符号',
        enableTimestamp: '启用时间戳',
        enableWordLevel: '启用词级别时间戳',
        apiHeader: 'API配置',
        apiKeyPlaceholder: '请输入API密钥（可选，优先使用全局配置）',
        endpoint: 'API Endpoint',
        endpointPlaceholder: '请输入API端点（可选，使用默认值）',
        regionPlaceholder: '请输入服务区域',
        timeout: '超时时间(秒)',
        maxRetries: '最大重试次数',
        retryDelay: '重试延迟(秒)',
        outputVars: '输出变量',
      },
      tts: {
        outputFormat: '输出格式',
        outputFormatPlaceholder: '请选择输出格式',
        url: 'URL链接',
        base64: 'Base64编码',
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择语音合成配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        basicHeader: '基础配置',
        provider: '服务提供商',
        openai: 'OpenAI TTS',
        aliyun: '阿里云语音合成',
        azure: 'Azure语音服务',
        tencent: '腾讯云语音合成',
        volcengine: '火山引擎语音合成',
        elevenlabs: 'ElevenLabs',
        model: '模型',
        modelPlaceholder: '请选择模型',
        text: '合成文本',
        textPlaceholder:
          '请输入要合成的文本，可使用 {变量名} 引用上方定义的变量',
        textHint: '使用 {变量名} 语法插入变量，例如：你好，{name}！',
        textVars: '文本变量',
        textVar: '文本变量',
        textVarPlaceholder: '选择前置节点的输出变量作为文本',
        textVarValuePlaceholder: '输入值或选择变量',
        addVar: '添加变量',
        voice: '音色',
        voicePlaceholder: '请选择音色',
        voiceId: '音色ID',
        voiceIdPlaceholder: '请输入自定义音色ID',
        language: '语言',
        languagePlaceholder: '请选择语言',
        zhCN: '中文（普通话）',
        zhTW: '中文（繁体）',
        enUS: '英语（美式）',
        enGB: '英语（英式）',
        jaJP: '日语',
        koKR: '韩语',
        esES: '西班牙语',
        frFR: '法语',
        deDE: '德语',
        ruRU: '俄语',
        speed: '语速',
        pitch: '音调',
        low: '低',
        normal: '正常',
        high: '高',
        volume: '音量',
        mute: '静音',
        emotion: '情感',
        emotionPlaceholder: '请选择情感风格',
        neutral: '中性',
        happy: '开心',
        sad: '悲伤',
        angry: '愤怒',
        calm: '平静',
        outputHeader: '输出配置',
        audioFormat: '音频格式',
        audioFormatPlaceholder: '请选择音频格式',
        sampleRate: '采样率',
        sampleRatePlaceholder: '请选择采样率',
        timeoutHeader: '超时配置',
        apiHeader: 'API配置',
        apiKeyPlaceholder: '请输入API密钥（可选，优先使用全局配置）',
        endpoint: 'API Endpoint',
        endpointPlaceholder: '请输入API端点（可选，使用默认值）',
        regionPlaceholder: '请输入Azure区域',
        timeout: '超时时间(秒)',
        maxRetries: '最大重试次数',
        retryDelay: '重试延迟(秒)',
        outputVars: '输出变量',
      },
      contentSafe: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择内容安全配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        basicHeader: '基础配置',
        provider: '工具供应商',
        providerPlaceholder: '请选择工具供应商',
        aliyun: '阿里云AI安全护栏',
        checkType: '检测类型',
        checkTypePlaceholder: '请选择检测类型',
        querySecurityCheck: '输入内容检测',
        responseSecurityCheck: '输出内容检测',
        querySecurityCheckCb: '出海输入内容检测',
        responseSecurityCheckCb: '出海输出内容检测',
        inputHeader: '输入配置',
        selectStringVarPlaceholder: '请选择String类型的变量',
        contentVar: '内容',
        contentTooltip: 'String类型，待检测文本，至少传入一项',
        contentPlaceholder: '请选择String类型的变量',
        chatId: '会话ID',
        chatIdTooltip:
          'String类型，标识一轮用户输入+大模型输出的交互记录，非必填',
        outputHeader: '输出变量',
        advice: '调用检测服务时，返回标准回答Advice',
        result: '检测的内容合规风险标签、置信分等结果',
        sensitiveResult: '检测的敏感内容风险标签、敏感样本等结果',
        attackResult: '检测的攻击内容风险标签、置信分等结果',
        riskLevel: '内容合规风险等级，返回值包括：high、medium、low、none',
        sensitiveLevel:
          '敏感等级，返回值包括：S0、S1、S2、S3、S4，数字越高敏感程度越高',
        attackLevel: '攻击等级，返回值包括：high、medium、low、none',
      },
      text_to_image: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择图像生成配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        basicHeader: '基础配置',
        provider: '服务提供商',
        providerPlaceholder: '请选择服务提供商',
        providerRequired: '请选择服务提供商',
        model: '模型',
        modelPlaceholder: '请选择模型',
        size: '图片尺寸',
        sizePlaceholder: '请选择图片尺寸',
        landscape: '横向',
        portrait: '纵向',
        n: '生成数量',
        count: '生成数量',
        promptHeader: '提示词配置',
        prompt: '正向提示词',
        promptPlaceholder:
          '请输入图像生成提示词，可使用 {变量名} 引用上方定义的变量',
        promptHint:
          '使用 {变量名} 语法插入变量，例如：A {style} painting of {subject}',
        promptVar: '提示词变量',
        promptVarPlaceholder: '选择前置节点的输出变量作为提示词',
        promptVarValuePlaceholder: '输入值或选择变量',
        addVar: '添加变量',
        negativePrompt: '负向提示词',
        negativePromptPlaceholder:
          '描述你不想在图像中出现的内容（可选），可使用 {变量名} 引用变量',
        apiKey: 'API Key',
        advancedHeader: '高级参数',
        quality: '质量',
        qualityPlaceholder: '请选择生成质量',
        standard: '标准',
        hd: '高清',
        qualityStandard: '标准',
        qualityHD: '高清',
        style: '风格',
        stylePlaceholder: '请选择图像风格',
        vivid: '生动',
        natural: '自然',
        styleVivid: '生动',
        styleNatural: '自然',
        seed: '随机种子',
        seedPlaceholder: '-1 表示随机',
        steps: '推理步数',
        cfgScale: '提示词相关性',
        outputFormat: '输出格式',
        outputFormatPlaceholder: '请选择输出格式',
        url: 'URL链接',
        base64: 'Base64编码',
        timeout: '超时时间(秒)',
        apiHeader: 'API配置',
        apiKeyPlaceholder: '请输入API密钥（可选，优先使用全局配置）',
        endpoint: 'API端点',
        endpointPlaceholder: '请输入API端点（可选，使用默认值）',
        maxRetries: '最大重试次数',
        retryDelay: '重试延迟(秒)',
        outputVars: '输出变量',
      },
      image_to_text: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择图像理解配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        providerHeader: '服务商配置',
        provider: '服务商',
        providerPlaceholder: '选择图像理解服务商',
        model: '模型',
        modelPlaceholder: '选择模型',
        customModel: '自定义模型',
        inputHeader: '图像输入',
        imageSource: '图像来源',
        imageSourcePlaceholder: '请选择图像来源',
        url: 'URL地址',
        base64: 'Base64数据',
        base64Image: 'Base64图像',
        file: '本地文件',
        variable: '从变量获取',
        imageUrl: '图像URL',
        imageUrlPlaceholder: '输入图像URL地址，输入$选择变量',
        urlVarPlaceholder: '输入URL地址或选择变量',
        base64Placeholder: '输入Base64编码的图像数据',
        base64VarPlaceholder: '输入Base64数据或选择变量',
        filePathPlaceholder: '输入服务器上的图像文件路径',
        imageVar: '图像变量',
        imageVarPlaceholder: '选择包含图像数据的变量',
        comparisonDivider: '对比图像',
        table: {
          source: '来源',
          value: '值',
          valuePlaceholder: '输入URL或Base64',
          selectVarPlaceholder: '输入URL或选择变量',
        },
        addImage: '添加对比图像',
        addVar: '添加变量',
        promptHeader: '提示词配置',
        systemPrompt: '系统提示词',
        systemPromptPlaceholder: '请输入系统提示词，用于设定AI的角色和行为规则',
        userPrompt: '用户提示词',
        userPromptPlaceholder:
          '请输入用户提示词，描述你希望模型对图像做什么分析，可使用 {变量名} 引用提示词变量',
        promptVarHint: '使用 {变量名} 语法插入提示词变量',
        promptVar: '从变量获取提示词',
        promptVarPlaceholder: '选择包含提示词的变量',
        promptVarValuePlaceholder: '输入值或选择变量',
        ocrHeader: 'OCR配置',
        language: '识别语言',
        autoDetect: '自动识别',
        zh: '中文',
        en: '英文',
        ja: '日文',
        ko: '韩文',
        detectDirection: '检测文字方向',
        returnPosition: '返回位置信息',
        positionHint: '启用后返回每个文字块的坐标位置',
        detectionHeader: '检测配置',
        categories: '检测类别',
        categoriesPlaceholder: '输入要检测的物体类别后按回车',
        categoriesHint: '常用类别: person, car, dog, cat, face, text',
        confidence: '置信度阈值',
        returnBBox: '返回边界框',
        paramsHeader: '模型参数',
        temperature: '温度',
        maxTokens: '最大Token数',
        detail: '图像细节级别',
        auto: '自动',
        low: '低',
        high: '高',
        detailHint: '高细节会消耗更多Token但识别更准确',
        apiHeader: 'API配置',
        apiKeyPlaceholder: '输入API Key',
        endpointPlaceholder: '自定义API端点 (可选)',
        timeout: '超时时间(秒)',
        outputHeader: '输出变量',
        outputVars: '输出变量',
        apiKey: 'API Key',
        endpoint: 'API 端点',
        providers: {
          aliyun: '阿里云 (通义千问VL)',
          tencent: '腾讯云',
          baidu: '百度云 (文心一言)',
          local: '本地模型',
        },
        advancedHeader: '高级设置',
      },
      voiceClone: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择声音克隆配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        basicHeader: '基础配置',
        provider: '服务提供商',
        providerPlaceholder: '请选择服务提供商',
        operation: '操作类型',
        operationPlaceholder: '请选择操作类型',
        operations: {
          create: '创建克隆声音',
          synthesize: '使用克隆声音合成',
          delete: '删除克隆声音',
          list: '列出已克隆声音',
        },
        voiceName: '声音名称',
        voiceNamePlaceholder: '请输入克隆声音的名称',
        voiceNameVarPlaceholder: '输入声音名称或选择变量',
        audioSource: '音频来源',
        audioSourcePlaceholder: '请选择音频来源',
        audioVar: '音频变量',
        audioVarPlaceholder: '选择前置节点的输出变量',
        description: '声音描述',
        descriptionPlaceholder: '请输入声音描述信息（可选）',
        descriptionVarPlaceholder: '输入声音描述或选择变量（可选）',
        voiceId: '声音ID',
        voiceIdPlaceholder: '请输入克隆声音的ID',
        voiceIdVarPlaceholder: '输入声音ID或选择变量',
        deleteIdPlaceholder: '请输入要删除的克隆声音ID',
        text: '合成文本',
        textPlaceholder:
          '请输入要合成的文本内容，可使用 {变量名} 引用上方定义的变量',
        textHint: '使用 {变量名} 语法插入变量',
        textVars: '文本变量',
        textVarValuePlaceholder: '输入值或选择变量',
        addVar: '添加变量',
        audioFormat: '音频格式',
        audioFormatPlaceholder: '请选择输出格式',
        advancedHeader: '高级设置',
        apiKey: 'API Key',
        apiKeyPlaceholder: '请输入API密钥（可选，优先使用全局配置）',
        endpoint: 'API端点',
        endpointPlaceholder: '请输入API端点（可选，使用默认值）',
        speed: '语速',
        pitch: '音调',
        inputVars: '输入变量',
        outputVars: '输出变量',
      },
      tokenizer: {
        inputVars: '输入变量',
        configSelectorHeader: '配置',
        configHeader: '模型配置',
        config: '配置',
        configPlaceholder: '请选择分词模型配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        model: '模型',
        modelPlaceholder: '请选择模型',
        mode: '模式',
        modePlaceholder: '请选择模式',
        modes: {
          split: '分词',
          count: '统计',
          analyze: '分析',
        },
        outputVars: '输出变量',
      },
      videoParser: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择视频解析配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        emptyDescription: '暂无配置',
        videoUrl: '视频URL',
        base64Video: 'Base64视频',
        videoUrlVarPlaceholder: '输入URL地址或选择变量',
        base64VideoVarPlaceholder: '输入Base64数据或选择变量',
        promptVarValuePlaceholder: '输入值或选择变量',
        addVar: '添加变量',
        basicConfig: '基础配置',
        taskType: '任务类型',
        taskTypePlaceholder: '选择任务类型',
        taskUnderstanding: '视频理解',
        taskSummarize: '视频摘要',
        videoInput: '视频输入',
        videoSource: '视频来源',
        videoSourcePlaceholder: '请选择视频来源',
        urlAddress: 'URL地址',
        base64Encode: 'Base64编码',
        promptConfig: '提示词配置',
        promptPlaceholder:
          '请输入提示词，描述你希望对视频做什么分析，可使用 {变量名} 引用提示词变量',
        promptHint:
          '使用 {变量名} 语法插入提示词变量，例如：分析视频中的 {subject} 内容',
        frameConfig: '帧提取配置',
        frameInterval: '帧间隔(秒)',
        frameIntervalPlaceholder: '1.0',
        maxFrames: '最大帧数',
        maxFramesPlaceholder: '10',
        startTime: '开始时间(秒)',
        startTimePlaceholder: '0',
        endTime: '结束时间(秒)',
        endTimePlaceholder: '视频结尾',
        extractKeyframesOnly: '只提取关键帧',
        analysisConfig: '分析配置',
        recognitionLanguage: '识别语言',
        selectLanguage: '选择语言',
        autoDetect: '自动检测',
        zh: '中文',
        en: '英文',
        ja: '日文',
        ko: '韩文',
        es: '西班牙语',
        fr: '法语',
        de: '德语',
        detectCategories: '检测类别',
        detectCategoriesPlaceholder: '输入检测类别后按回车',
        confidenceThreshold: '置信度阈值',
        enableTimestamp: '启用时间戳',
        modelParams: '模型参数',
        temperature: '温度',
        maxTokens: '最大Token数',
        maxTokensPlaceholder: '2000',
        advancedConfig: '高级配置',
        timeout: '超时时间(秒)',
        timeoutPlaceholder: '300',
        maxRetries: '最大重试次数',
        maxRetriesPlaceholder: '2',
        retryDelay: '重试延迟(秒)',
        retryDelayPlaceholder: '2',
        outputVars: '输出变量',
      },
      videoGeneration: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择视频生成配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        basicHeader: '基础配置',
        inputMode: '输入模式',
        inputModePlaceholder: '请选择输入模式',
        inputModeText: '文本',
        inputModeImage: '图片',
        prompt: '提示词',
        promptPlaceholder: '请输入视频描述文本',
        imageUrl: '图片 URL',
        imageUrlPlaceholder: '图生视频模式下请输入图片 URL，输入$选择变量',
        imagePrompt: '图片提示词',
        imagePromptPlaceholder: '可选，用于引导图生视频的文本描述',
        duration: '时长（秒）',
        durationPlaceholder: '5',
        resolution: '分辨率',
        resolutionPlaceholder: '请选择输出分辨率',
        size1280x720: '1280x720',
        size1920x1080: '1920x1080',
        watermark: '水印',
        promptExtend: '提示词扩展',
        outputVars: '输出变量',
      },
      gen3d: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择 3D 生成配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        basicHeader: '基础配置',
        inputMode: '输入模式',
        inputModePlaceholder: '请选择输入模式',
        inputModeImage: '图生 3D',
        inputModeText: '文生 3D',
        imageUrl: '图片 URL',
        imageUrlPlaceholder:
          '图生 3D 模式下请输入图片 URL，支持 JPG、PNG、WEBP，输入$选择变量',
        prompt: '提示词',
        promptPlaceholder: '3D 模型描述文本，文生 3D 模式下必填',
        outputFormat: '输出格式',
        outputFormatPlaceholder: '请选择输出格式',
        formatGlb: 'GLB（推荐）',
        formatObj: 'OBJ',
        formatFbx: 'FBX',
        formatPly: 'PLY',
        textureQuality: '贴图质量',
        textureQualityPlaceholder: '请选择贴图质量',
        qualityLow: '低',
        qualityMedium: '中',
        qualityHigh: '高',
        withTexture: '生成贴图',
        seed: '随机种子',
        seedPlaceholder: '0 表示随机',
        outputVars: '输出变量',
      },
    },
    flow: {
      iterator: {
        name: '迭代器节点',
        description: '遍历数组，对每个元素执行循环体，自动收集结果',
        iterationSettings: '迭代设置',
        arrayVar: '数组变量',
        arrayVarPlaceholder: '选择要遍历的数组',
        iterationVars: '迭代变量',
        itemVarName: '元素变量名',
        itemVarNamePlaceholder: 'item',
        itemVarNameTooltip: '循环体内引用当前元素的变量名',
        indexVarName: '索引变量名',
        indexVarNamePlaceholder: 'index',
        indexVarNameTooltip: '循环体内引用当前索引的变量名',
        elementSubFields: '元素子字段',
        elementSubFieldsTooltip: '当元素是对象时，可指定要暴露的子字段名',
        elementSubFieldsPlaceholder: '输入字段名，按Enter添加',
        executionConfig: '执行配置',
        parallelExecution: '并行执行',
        maxConcurrency: '最大并发',
        errorHandling: '错误处理',
        errorStrategies: {
          continue: '继续执行',
          stop: '停止迭代',
        },
        outputVars: '输出变量',
      },
      conditional: {
        addBranch: '新增分支',
        defaultBranch: '默认分支',
        branchIndex: '分支 {index}',
        delete: '删除',
      },
      loop: {
        loopSettings: '循环设置',
        loopType: '循环类型',
        loopTypePlaceholder: '请选择循环类型',
        loopTypes: {
          count: '次数',
          while: '条件',
        },
        iteratorTip: '如需遍历数组，请使用"迭代器"节点',
        loopCount: '循环次数',
        loopCountVar: '次数/变量',
        countOrVarPlaceholder: '输入次数或选择变量',
        loopCondition: '循环条件',
        loopConditionPlaceholder: '输入条件表达式',
        conditionExtra: '可使用中间变量和条件变量，当条件为 true 时继续循环',
        conditionVar: '条件变量',
        addConditionVar: '添加条件变量',
        safetyLimit: '安全限制',
        maxIterations: '最大迭代次数',
        maxIterationsPlaceholder: '100',
        allowInfiniteLoop: '允许无限循环',
        middleVars: '中间变量',
        middleVarsDesc:
          '中间变量在循环开始时初始化，每次迭代可读取和修改，循环结束后的最终值作为输出',
        varNamePlaceholder: '变量名',
        typePlaceholder: '类型',
        types: {
          string: '字符串',
          number: '数字',
          boolean: '布尔',
          array: '数组',
          object: '对象',
        },
        initialValuePlaceholder: '初始值',
        addMiddleVar: '添加中间变量',
        executionConfig: '执行配置',
        errorHandling: '错误处理',
        errorStrategies: {
          continue: '继续执行',
          stop: '停止循环',
        },
        outputVars: '输出变量',
      },
      aggregator: {
        aggregatorGroup: '聚合分组',
        placeholder: '请输入聚合后变量名',
        inputVars: '输入变量',
        addInputVar: '+ 新增输入变量',
        varFormat: '变量聚合格式(可选)',
        varFormatPlaceholder: '请输入, 例如: {var1}_{var2}',
        addGroup: '+ 新增分组',
        outputVars: '输出变量',
        tableName: '变量名',
        tableType: '变量类型',
        tableFormat: '聚合格式',
      },
      humanInput: {
        taskInfo: '任务信息',
        taskTitle: '任务标题',
        taskTitlePlaceholder: '输入任务标题',
        taskDesc: '任务描述',
        taskDescPlaceholder: '任务说明',
        operationInstructions: '操作说明',
        operationInstructionsPlaceholder: '给处理人的操作指引',
        formFields: '表单字段',
        fieldPrefix: '字段',
        unnamed: '未命名',
        fieldName: '字段名',
        fieldNamePlaceholder: '英文字段名',
        fieldLabel: '显示标签',
        fieldLabelPlaceholder: '显示的中文标签',
        fieldType: '字段类型',
        types: {
          text: '单行文本',
          textarea: '多行文本',
          number: '数字',
          select: '下拉选择',
          radio: '单选',
          checkbox: '多选',
          date: '日期',
          datetime: '日期时间',
          file: '文件上传',
          boolean: '开关',
        },
        required: '是否必填',
        placeholder: '占位提示',
        placeholderInput: '输入框占位文字',
        defaultValue: '默认值',
        defaultValuePlaceholder: '字段默认值',
        options: '选项',
        optionsPlaceholder: '输入选项值后按回车',
        addField: '添加字段',
        assignConfig: '指派配置',
        assignee: '指派人',
        assigneePlaceholder: '输入指派人邮箱后按回车',
        assigneeFromVar: '从变量获取指派人',
        assigneeVarPlaceholder: '选择包含指派人列表的变量',
        allowReassign: '允许转派',
        allowReject: '允许拒绝',
        notifyConfig: '通知配置',
        notifyType: '通知方式',
        notifyTypes: {
          none: '不通知',
          email: '邮件',
          webhook: 'Webhook',
          sms: '短信',
          dingtalk: '钉钉',
          feishu: '飞书',
        },
        notifyEndpoint: '通知端点',
        notifyEndpointPlaceholder: '邮箱/URL/手机号等',
        timeoutConfig: '超时配置',
        timeoutSeconds: '超时时间(秒)',
        defaultTimeoutTip: '默认24小时(86400秒)',
        outputVars: '输出变量',
        formStyle: '表单样式',
        layout: '布局方式',
        layouts: {
          vertical: '垂直布局',
          horizontal: '水平布局',
          inline: '行内布局',
        },
        labelWidth: '标签宽度',
        submitText: '提交按钮',
        rejectText: '拒绝按钮',
        cancelText: '取消按钮',
        fieldTypeGroups: {
          basic: '基础类型',
          dateTime: '日期时间',
          fileTypes: '文件类型',
          advancedTypes: '高级类型',
        },
        fieldTypes: {
          time: '时间',
          rating: '评分',
          json: 'JSON编辑器',
          image: '图片上传',
        },
        readonly: '只读',
        hidden: '隐藏',
        fieldDesc: '字段描述',
        fieldDescPlaceholder: '字段的详细说明（可选）',
        notifyConfigLabel: '通知配置',
        selectNotifyConfig: '选择通知配置',
        noNotifyConfig: '暂无通知配置',
        notifyTypeNone: '不通知',
        notifyTypeEmail: '邮件',
        notifyTypeDingtalk: '钉钉',
        notifyTypeFeishu: '飞书',
        notifyTypeWechat: '企业微信',
        notifyTypeWebhook: 'Webhook',
        notifyTypeSms: '短信',
        emailProvider: '邮件服务商',
        emailProviderPlaceholder: '选择邮件服务商快速配置',
        customConfig: '自定义配置',
        smtpServer: 'SMTP服务器',
        port: '端口',
        isHtml: 'HTML格式',
        username: '用户名',
        usernamePlaceholder: '登录用户名或邮箱',
        password: '密码/授权码',
        passwordPlaceholder: '密码或应用专用密码',
        passwordTip: '部分邮箱需要使用授权码而非登录密码',
        from: '发件人邮箱',
        fromName: '发件人名称',
        subject: '邮件主题',
        notifyTemplate: '通知模板',
        notifyTemplatePlaceholder:
          '支持变量: {{title}}, {{description}}, {{assignees}}',
        dingtalkWebhook: '钉钉机器人Webhook',
        dingtalkWebhookTip:
          '群设置 → 智能群助手 → 添加机器人 → 自定义 → 复制Webhook地址',
        feishuWebhook: '飞书机器人Webhook',
        feishuWebhookTip:
          '群设置 → 群机器人 → 添加机器人 → 自定义机器人 → 复制Webhook地址',
        wechatWebhook: '企业微信机器人Webhook',
        wechatWebhookTip:
          '群聊 → 右上角菜单 → 添加群机器人 → 新建机器人 → 复制Webhook地址',
        webhookTip: '将以POST方式发送JSON格式的任务信息到此地址',
      },
      subworkflow: {
        configHeader: '子工作流配置',
        subworkflow: '子工作流',
        subworkflowPlaceholder: '请选择子工作流',
        viewConfig: '查看配置',
        version: '版本',
        versionPlaceholder: '请选择子工作流版本',
        latestVersion: 'latest',
        latestVersionDesc: 'latest 代表每次运行自动选择最新发布版本',
        inputMapping: '输入映射',
        outputMapping: '输出映射',
        mappingPrefix: '映射',
        sourceVar: '源变量',
        targetVar: '目标变量',
        targetVarPlaceholder: '请输入目标变量名',
        alias: '别名',
        aliasPlaceholder: '请输入别名',
        defaultValue: '默认值',
        defaultValuePlaceholder: '请输入默认值',
        required: '是否必须',
        addInputMapping: '添加输入映射',
        addOutputMapping: '添加输出映射',
        execConfig: '执行配置',
        timeout: '超时时间（秒）',
        errorHandling: '错误处理方式',
        errorHandlingPlaceholder: '请选择错误处理方式',
        maxRetries: '最大重试次数',
        unnamedNode: '未命名节点',
        loadVersionError: '加载版本列表失败:',
      },
      wait: {
        waitType: '等待类型',
        waitTypePlaceholder: '选择等待类型',
        waitTypes: {
          time: '固定时间',
          until: '等待到指定时间',
          webhook: '等待Webhook回调',
          event: '等待事件触发',
          approval: '等待人工审批',
        },
        timeConfig: '时间配置',
        waitSeconds: '等待秒数',
        waitMilliseconds: '等待毫秒数',
        targetTime: '目标时间',
        webhookConfig: 'Webhook配置',
        webhookId: 'Webhook ID',
        webhookIdPlaceholder: '唯一标识符',
        webhookSecret: 'Webhook密钥',
        webhookSecretPlaceholder: '可选，用于验证回调',
        callbackUrl: '回调URL:',
        eventConfig: '事件配置',
        eventName: '事件名称',
        eventNamePlaceholder: '要监听的事件名称',
        eventCondition: '事件条件',
        eventConditionPlaceholder: '可选，事件过滤条件表达式',
        approvalConfig: '审批配置',
        approvalTitle: '审批标题',
        approvalTitlePlaceholder: '审批标题',
        approvalDesc: '审批描述',
        approvalDescPlaceholder: '审批说明',
        approver: '审批人',
        approverPlaceholder: '输入审批人邮箱后按回车',
        minApprovals: '最少审批人数',
        notifyType: '通知方式',
        notifyTypes: {
          email: '邮件',
          webhook: 'Webhook',
          sms: '短信',
        },
        notifyUrl: '通知URL',
        notifyUrlPlaceholder: 'Webhook通知URL',
        timeoutConfig: '超时配置',
        timeoutSeconds: '超时时间(秒)',
        timeoutTip: '最长等待时间，超时后继续执行',
        outputVars: '输出变量',
      },
      streamWait: {
        inputVars: '输入变量',
        timeout: '超时时间(秒)',
        outputVars: '输出变量',
      },
    },
    database: {
      common: {
        noConfigConfigured: '暂无配置，请先创建',
        operationType: '操作类型',
        operationPlaceholder: '请选择操作类型',
        tableName: '表名',
        tableNamePlaceholder: '请输入表名',
        tableSelectPlaceholder: '请选择表名',
        condition: '条件',
        conditionPlaceholder: '请输入WHERE条件',
        data: '数据',
        sql: 'SQL语句',
        maxResults: '最大结果数',
        database: '数据库',
        databasePlaceholder: '请选择数据库',
        databaseInstance: '数据库实例',
        databaseInstancePlaceholder: '请选择数据库实例',
        inputVars: '输入变量',
        outputVars: '输出变量',
        offlineMode: '是否离线模式',
        operations: {
          create_database: '创建数据库',
          list_databases: '列出数据库',
          create_table: '创建表',
          insert: '插入',
          update: '更新',
          delete: '删除',
          query: '查询',
          execute: '执行SQL',
          count: '计数',
          insert_vector: '插入向量',
          create_vector_index: '创建向量索引',
          search_cosine: '向量搜索',
          search: '向量搜索',
          hybrid_search: '混合搜索',
          insert_record: '插入Record',
          list_tables: '列出表',
          set: '设置',
          get: '获取',
          incr: '自增',
          exists: '是否存在',
          ttl: '获取过期时间',
          hget: '哈希获取',
          hset: '哈希设置',
          hgetall: '哈希获取所有',
          lpush: '列表左推',
          rpush: '列表右推',
          lrange: '列表范围',
          create_collection: '创建集合',
          drop_collection: '删除集合',
          has_collection: '集合是否存在',
          list_collections: '列出集合',
          load_collection: '加载集合',
          release_collection: '释放集合',
          create_index: '创建索引',
          flush: '刷新',
        },
      },
      mysql: {
        noDatabaseConfigured: '此工作空间未配置任何数据库',
        oneClickDeploy: '一键部署',
        externalConfiguration: '外部配置',
        managed: '内置',
        external: '外部配置',
      },
      milvus: {
        configHeader: 'MiLvus操作',
        config: '配置',
        configPlaceholder: '请选择Milvus数据库配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        collectionName: '集合名称',
        collectionPlaceholder: '请输入集合名称',
        partitionName: '分区名称',
        partitionPlaceholder: '请输入分区名称',
        description: '描述',
        descriptionPlaceholder: '请输入描述',
        shardsNum: '碎片数量',
        shardsNumPlaceholder: '请输入碎片数量',
        fields: '字段集',
        fieldName: '名称',
        fieldNamePlaceholder: '请输入名称',
        fieldType: '类型',
        fieldTypePlaceholder: '请选择类型',
        isPrimaryKey: '是否为主Key',
        isAutoId: '是否自增',
        maxLength: '最大长度',
        dimension: '维度',
        lengthPlaceholder: '请输入长度',
        addField: '添加字段',
        vectorField: '向量字段',
        vectorFieldPlaceholder: '请输入向量字段名',
        indexType: '索引类型',
        indexTypePlaceholder: '请选择索引类型',
        metricType: 'Metric Type',
        metricTypePlaceholder: '请选择Metric Type',
        searchParams: '搜索参数',
        topK: 'TopK',
        topKPlaceholder: '请输入TopK',
        lists: 'Lists',
        m: 'M',
        efConstruction: 'EF Construction',
        partitionPlaceholderOptional: '请输入分区名称（可选）',
        outputFields: '输出字段',
        outputFieldsPlaceholder: '请输入输出字段，逗号分隔',
        deleteExpression: '删除条件',
        deleteExpressionPlaceholder: '例如: id in [1, 2, 3]',
        deleteExpressionTip: '使用Milvus表达式语法指定要删除的数据',
        queryExpression: '查询条件',
        queryExpressionPlaceholder: '例如: id >= 0',
        queryExpressionTip: '使用Milvus表达式语法，留空则查询所有',
        offset: '偏移量',
        limit: '限制数量',
      },
      postgres: {
        configHeader: 'PostgreSQL操作',
        config: '配置',
        configPlaceholder: '请选择PostgreSQL数据库配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        columnName: '列名',
        columnNamePlaceholder: '请输入向量列名',
        limit: '限制数量',
        metricType: '向量距离类型',
        metricTypePlaceholder: '请选择 cosine/euclidean/dotproduct',
        expression: '过滤条件',
        expressionPlaceholder: '例如: category = {category} AND score > 0.5',
        textColumn: '文本列名',
        textColumnPlaceholder: '混合搜索的文本列',
        textQuery: '文本查询',
        textQueryPlaceholder: '混合搜索的文本查询变量',
        textWeight: '文本权重',
        vectorWeight: '向量权重',
        sqlPlaceholder: '请输入 SQL 语句，支持 {var_name} 变量',
        indexType: '索引类型',
        indexTypePlaceholder: '请选择索引类型',
        lists: 'Lists',
        m: 'M',
        efConstruction: 'EF Construction',
      },
      redis: {
        configHeader: 'Redis操作',
        noDatabaseConfigured: '此工作空间未配置Redis数据库',
        field: 'Field',
        fieldFormat: 'Field拼接处理',
        fieldFormatPlaceholder: '请输入Field拼接处理, 输入 $ 选择变量',
        fieldFormatTip: '变量名写在{}中, 例如: {field1}_{field2}',
        key: 'Key',
        keyFormat: 'Key拼接处理',
        keyFormatPlaceholder: '请输入Key拼接处理, 输入 $ 选择变量',
        keyFormatTip: '变量名写在{}中, 例如: {key1}_{key2}',
        value: 'Value',
        maxCount: '保留条数',
        start: 'Start',
        stop: 'Stop',
        stopTip: '-1表示列表末尾',
        expiration: '过期时间',
        seconds: '秒',
      },
      sqlite: {
        conditionTip: "例如：WHERE DATE(created_at) = '{date}'",
        dataTip:
          '支持拼接变量，如：aaa_{var_name};\n若不希望设置空值，则应该删除数据行，否则会设置为空字符串',
      },
      byteHouse: {
        config: '配置',
        configPlaceholder: '请选择ByteHouse数据库配置',
        noConfigConfigured: '暂无配置，请先创建配置',
      },
      documentExtractor: {
        configHeader: '文件提取配置',
        sourceType: '文件来源',
        sourceTypePlaceholder: '选择文件来源',
        sources: {
          file: '本地文件',
          url: 'URL地址',
          base64: 'Base64内容',
        },
        docType: '文档类型',
        docTypePlaceholder: '自动识别文档类型',
        docTypes: {
          auto: '自动识别',
          pdf: 'PDF文档',
          docx: 'Word文档',
          xlsx: 'Excel表格',
          txt: '文本文件',
          html: 'HTML网页',
          image: '图片文件',
          json: 'JSON数据',
          csv: 'CSV表格',
        },
        urlAddress: 'URL地址',
        urlPlaceholder: '请输入文件下载URL',
        inputVar: '输入变量',
        inputVarPlaceholder: '选择包含文件内容的变量',
        extractHeader: '提取配置',
        encoding: '文件编码',
        encodingPlaceholder: '选择文件编码',
        maxPages: '最大页数',
        noLimit: '不限制',
        timeout: '提取超时(秒)',
        extractMetadata: '提取元数据',
        extractImages: '提取图片',
        ocrHeader: 'OCR配置',
        enableOcr: '启用OCR',
        ocrProvider: 'OCR提供商',
        ocrProviderPlaceholder: '选择OCR引擎',
        apiKey: 'API Key',
        apiKeyPlaceholder: '输入API Key',
        secretKey: 'Secret Key',
        secretKeyPlaceholder: '输入Secret Key',
      },
      template: {
        configHeader: '模板配置',
        engine: '模板引擎',
        enginePlaceholder: '选择模板引擎',
        syntaxLabel: '支持语法：',
        // eslint-disable-next-line no-template-curly-in-string
        notSupportSimple: '不支持 ${var} 语法',
        templateContent: '模板内容',
        // eslint-disable-next-line no-template-curly-in-string
        templatePlaceholder: '例如: 你好, ${name}!',
        outputFormat: '输出格式',
        formats: {
          string: '纯文本',
          json: 'JSON对象',
          html: 'HTML富文本',
        },
        escapeHtml: 'HTML转义',
        strictMode: '严格模式',
        strictModeTip: '变量不存在时抛出错误',
        varMapping: '变量映射',
        colName: '变量名',
        colSource: '变量来源',
        placeholderName: '变量名',
        placeholderSource: '选择变量',
        addVar: '添加变量',
      },
      transform: {
        inputConfig: '输入配置',
        inputVar: '输入变量',
        inputVarPlaceholder: '选择要转换的变量',
        staticInput: '静态输入',
        staticInputPlaceholder: '或者直接输入要转换的内容',
        transformConfig: '转换配置',
        transformType: '转换类型',
        transformTypePlaceholder: '选择数据转换方式',
        patterns: {
          regex: '正则表达式',
          string: '查找字符串',
        },
        placeholders: {
          regex: '输入正则表达式',
          string: '要查找的字符串',
          replaceRegex: '替换后的字符串（支持 $1, $2 等分组引用）',
          replaceString: '替换后的字符串',
        },
        replaceWith: '替换为',
        separator: '分隔符',
        separatorPlaceholder: '输入分隔符，如 , 或 \n',
        start: '开始索引',
        end: '结束索引',
        length: '填充长度',
        padChar: '填充字符',
        padCharPlaceholder: '默认空格',
        aesKey: '密钥',
        keyPlaceholder: 'AES加密/解密密钥',
        jsonPath: 'JSONPath',
        jsonPathPlaceholder: '如 $.store.book[*].author',
        regex: '正则表达式',
        regexPlaceholder: '输入正则表达式',
        groupIndex: '捕获组索引',
        outputFormat: '输出格式',
        formats: {
          string: '字符串',
          bytes: '二进制',
          base64: 'Base64',
        },
        types: {
          base64_encode: 'Base64编码',
          base64_decode: 'Base64解码',
          url_encode: 'URL编码',
          url_decode: 'URL解码',
          html_encode: 'HTML实体编码',
          html_decode: 'HTML实体解码',
          hex_encode: 'Hex编码',
          hex_decode: 'Hex解码',
          json_parse: 'JSON解析',
          json_stringify: 'JSON序列化',
          xml_to_json: 'XML转JSON',
          json_to_xml: 'JSON转XML',
          html_to_text: 'HTML转纯文本',
          markdown_to_html: 'Markdown转HTML',
          md5: 'MD5哈希',
          sha1: 'SHA1哈希',
          sha256: 'SHA256哈希',
          sha512: 'SHA512哈希',
          aes_encrypt: 'AES加密',
          aes_decrypt: 'AES解密',
          uppercase: '转为大写',
          lowercase: '转为小写',
          trim: '去除首尾空格',
          replace: '字符串替换',
          regex_replace: '正则替换',
          split: '字符串分割',
          join: '集合连接',
          substring: '字符串截取',
          pad_start: '首部填充',
          pad_end: '尾部填充',
          jsonpath: 'JSONPath提取',
          regex_match: '正则匹配',
          regex_extract: '正则提取',
          gzip_compress: 'Gzip压缩',
          gzip_decompress: 'Gzip解压缩',
        },
      },
    },
    io: {
      common: {
        configHeader: '配置',
        advancedConfig: '高级配置',
        sendConfig: '发送配置',
        inputVars: '输入变量',
        outputVars: '输出变量',
      },
      cloudStorage: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择云存储配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        providerConfig: '服务商配置',
        provider: '服务商',
        providerPlaceholder: '请选择云存储服务商',
        operation: '操作类型',
        operationPlaceholder: '请选择操作',
        authConfig: '认证配置',
        folder: '文件夹',
        folderPlaceholder:
          '输入文件夹路径（支持嵌套变量，例如：a/b/$[folder1]）',
        pathConfig: '路径配置',
        path: '路径',
        pathPlaceholder: '输入文件或文件夹路径',
        pathVar: '路径变量',
        pathVarPlaceholder: '选择包含路径的变量',
        destPath: '目标路径',
        destPathPlaceholder: '输入目标路径',
        destVar: '目标路径变量',
        destVarPlaceholder: '选择目标路径变量',
        uploadConfig: '上传配置',
        source: '文件来源',
        sources: {
          local: '本地上传',
          variable: '从变量获取',
          manual: '手动输入',
        },
        localFile: '选择文件',
        selectLocalFile: '选择本地文件',
        remotePath: '远程路径',
        remotePathPlaceholder: '保存到云端的路径',
        fileNameVar: '文件名变量',
        fileNameVarPlaceholder: '从变量获取文件名',
        contentVar: '内容变量',
        contentVarPlaceholder: '从变量获取文件内容',
        fileName: '文件名',
        fileNamePlaceholder: '输入文件名',
        content: '文本内容',
        contentPlaceholder: '请输入文本内容',
        overwrite: '覆盖已存在',
        createParents: '自动创建父目录',
        downloadConfig: '下载配置',
        saveMethod: '保存方式',
        saveToVar: '保存到变量',
        saveToLocal: '保存到本地',
        localPath: '本地路径',
        localPathPlaceholder: '服务器上的保存路径',
        outputFormat: '输出格式',
        formats: {
          base64: 'Base64编码',
          text: '纯文本',
          binary: '二进制流',
        },
        listConfig: '列表配置',
        recursive: '递归列出',
        pattern: '匹配模式',
        patternPlaceholder: '如 *.txt, *.pdf',
        limit: '最大数量',
        includeFolders: '包含文件夹',
        sortBy: '排序字段',
        sortOrder: '排序方式',
        shareConfig: '分享配置',
        password: '访问密码',
        passwordPlaceholder: '可选，不填即公开',
        expireDays: '有效期(天)',
        expireDaysPlaceholder: '0表示永久有效',
        accessLimit: '访问次数限制',
        accessLimitPlaceholder: '0表示无限制',
        searchConfig: '搜索配置',
        keyword: '搜索关键词',
        keywordPlaceholder: '输入搜索内容',
        keywordVar: '关键词变量',
        keywordVarPlaceholder: '从变量获取搜索关键词',
        fileType: '文件类型',
        fileTypes: {
          folder: '文件夹',
          image: '图片',
          video: '视频',
          audio: '音频',
          document: '文档',
        },
        timeout: '超时秒数',
        retryCount: '重试次数',
        providers: {
          aliyun_drive: '阿里云盘',
          baidu_pan: '百度网盘',
          google_drive: 'Google Drive',
          onedrive: 'OneDrive',
          dropbox: 'Dropbox',
          s3: 'AWS S3',
          oss: '阿里云 OSS',
          cos: '腾讯云 COS',
          webdav: 'WebDAV',
        },
        operations: {
          list: '列出文件',
          upload: '上传文件',
          download: '下载文件',
          delete: '删除文件',
          move: '移动/重命名',
          copy: '复制文件',
          create_folder: '创建文件夹',
          get_info: '获取信息',
          share: '分享文件',
          search: '搜索文件',
        },
        placeholders: {
          accessToken: '输入Access Token',
          refreshToken: '输入Refresh Token',
          clientId: '输入Client ID',
          clientSecret: '输入Client Secret',
          accessKey: '输入Access Key',
          secretKey: '输入Secret Key',
          region: '如 cn-hangzhou, us-east-1',
          bucket: '输入Bucket名称',
          endpoint: '自定义Endpoint (可选)',
          davHost: '如 https://dav.example.com',
          username: '输入用户名',
          password: '输入密码',
        },
        sortFields: {
          size: '文件大小',
          modified_time: '修改时间',
          name: '文件名',
        },
        errors: {
          noFile: '未能获取到文件对象',
          readFailed: '文件读取失败',
        },
        selectFileSuccess: '文件 {name} 已选择',
      },
      webSearch: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择搜索配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        queryLabel: '搜索关键词',
        queryPlaceholder: '输入搜索关键词或选择变量',
        engineHeader: '搜索引擎',
        engine: '搜索引擎',
        enginePlaceholder: '选择搜索引擎',
        engines: {
          searxng: 'SearXNG (自建服务)',
          google: 'Google (需要API Key)',
          bing: 'Bing (需要API Key)',
        },
        searxngConfig: {
          baseUrl: '服务地址',
          baseUrlPlaceholder: 'https://your-searxng-instance.com',
          baseUrlExtra: 'SearXNG是开源的元搜索引擎，需要自行部署',
          engines: '指定引擎',
          enginesPlaceholder: '留空则使用默认引擎',
          engineGroups: {
            general: '通用搜索',
            academic: '学术搜索',
            news: '新闻',
            other: '其他',
          },
        },
        searchParamsHeader: '搜索参数',
        maxResults: '最大结果数',
        timeout: '超时时间(秒)',
        language: '语言',
        timeRange: '时间范围',
        timeRangeOptions: {
          unlimited: '不限',
          day: '最近一天',
          week: '最近一周',
          month: '最近一月',
          year: '最近一年',
        },
        categories: '搜索类别',
        categoryOptions: {
          general: '网页',
          images: '图片',
          news: '新闻',
          videos: '视频',
          science: '学术',
        },
        safeSearch: '安全搜索',
        safeSearchOptions: {
          off: '关闭',
          moderate: '中等',
          strict: '严格',
        },
        outputVarsHeader: '输出变量',
      },
      file: {
        operationConfig: '操作配置',
        operation: '操作类型',
        operationPlaceholder: '选择操作类型',
        operations: {
          read: '读取文件',
          write: '写入文件',
          append: '追加写入',
          delete: '删除文件',
          copy: '复制文件',
          move: '移动文件',
          exists: '检查存在',
          stat: '获取信息',
          list: '列出目录',
          mkdir: '创建目录',
          compress: '压缩文件',
          decompress: '解压文件',
        },
        pathConfig: '路径配置',
        source: '文件来源',
        sources: {
          server: '服务器路径',
          upload: '本地上传',
          variable: '从变量获取',
        },
        path: '文件路径',
        pathPlaceholder:
          '输入服务器文件路径，如 /data/file.txt。输入 $ 选择变量',
        uploadFile: '上传文件',
        selectFile: '选择文件',
        destPath: '目标路径',
        destPathPlaceholder: '输入目标路径，如 /data/file.txt。输入 $ 选择变量',
        readConfig: '读取配置',
        format: '文件格式',
        encoding: '文件编码',
        writeConfig: '写入配置',
        content: '文件内容',
        contentPlaceholder: '要写入的内容',
        contentVar: '从变量获取内容',
        contentVarPlaceholder: '选择包含内容的变量',
        overwrite: '覆盖已存在',
        createDirs: '自动创建目录',
        csvConfig: 'CSV配置',
        delimiter: '分隔符',
        delimiterPlaceholder: '默认为逗号',
        hasHeader: '包含表头',
        columns: '列名',
        columnsPlaceholder: '输入列名后按回车',
        listConfig: '列出配置',
        pattern: '匹配模式',
        patternPlaceholder: '如 *.txt, *.pdf',
        recursive: '递归',
        copyConfig: '复制/移动配置',
        selectFileSuccess: '文件 {name} 已选择',
      },
      http: {
        requestConfig: '请求配置',
        requestMethod: '请求方法',
        requestMethodPlaceholder: '请选择请求方法',
        authRequired: '需要认证',
        responseConfig: '响应配置',
        statusCode: '状态码',
        statusCodePlaceholder: '请输入状态码',
        headers: '响应头',
        jsonFormat: 'JSON格式',
        streaming: '流式输出',
        input: '输入',
      },
      message: {
        configHeader: '配置',
        config: '配置',
        configPlaceholder: '请选择消息通知配置',
        noConfigConfigured: '暂无配置，请先创建配置',
        channelConfig: '渠道配置',
        channel: '消息渠道',
        channelPlaceholder: '选择消息渠道',
        messageContent: '消息内容',
        to: '收件人',
        toPlaceholder: '输入收件人后按回车',
        toVar: '从变量获取收件人',
        toVarPlaceholder: '选择包含收件人的变量',
        subject: '主题',
        subjectPlaceholder: '邮件主题',
        contentType: '内容类型',
        content: '消息内容',
        contentPlaceholder: '消息内容，支持输入$引用变量',
        timeout: '超时秒数',
        retryCount: '重试次数',
        emailConfig: '邮件服务器配置',
        host: 'SMTP服务器',
        hostPlaceholder: '如 smtp.example.com',
        port: '端口',
        username: '用户名',
        password: '密码',
        from: '发件人邮箱',
        fromName: '发件人名称',
        useTls: '使用TLS',
        dingtalkConfig: '钉钉机器人配置',
        accessToken: 'Access Token',
        secret: '加签密钥',
        atMobiles: '@指定手机号',
        atMobilesPlaceholder: '输入手机号后按回车',
        atAll: '@所有人',
        feishuConfig: '飞书机器人配置',
        webhookUrl: 'Webhook URL',
        wechatConfig: '企业微信配置',
        slackConfig: 'Slack配置',
        channelName: '频道',
        channelNamePlaceholder: '#channel-name',
        botName: '机器人名称',
        icon: '图标',
        iconPlaceholder: ':robot:',
        telegramConfig: 'Telegram配置',
        chatId: 'Chat ID',
        smsConfig: '短信配置',
        provider: '服务商',
        signName: '签名名称',
        templateCode: '模板代码',
        webhookConfig: 'Webhook配置',
        method: 'HTTP方法',
        async: '异步发送',
        asyncTip: '启用后不等待发送结果，直接继续执行',
        channels: {
          email: '邮件',
          dingtalk: '钉钉',
          feishu: '飞书',
          wechat: '企业微信',
          slack: 'Slack',
          telegram: 'Telegram',
          sms: '短信',
          webhook: 'Webhook',
        },
        contentTypes: {
          text: '纯文本',
          html: 'HTML',
          markdown: 'Markdown',
        },
        smsProviders: {
          aliyun: '阿里云',
          tencent: '腾讯云',
        },
      },
      tcp: {
        inputConfig: 'TCP输入配置',
        outputConfig: 'TCP输出配置',
        protocol: '执行标识名称',
        protocolPlaceholder: '请输入执行标识名称',
        protocolType: '执行标识类型',
        protocolTypePlaceholder: '请选择执行标识类型',
        identity: '连接标识字段',
        identityPlaceholder: '请输入用于连接标识的字段名',
        streaming: '流式传输',
        inputVars: '输入变量',
        contentVars: '内容变量',
      },
      token: {
        authConfig: '鉴权配置',
        tokenType: 'Token类型',
        tokenTypePlaceholder: '请选择Token操作',
        modes: {
          generate: '生成Token',
          verify: '验证Token',
        },
        uid: 'Uid',
        token: 'Token',
      },
      humanInput: {
        taskInfo: '任务信息',
        taskTitle: '任务标题',
        taskTitlePlaceholder: '请输入任务显示的名称',
        taskDesc: '任务说明',
        taskDescPlaceholder: '向办理人描述任务背景',
        operationInstructions: '操作指引',
        operationInstructionsPlaceholder: '指导办理人如何进行操作',
        formFields: '表单字段',
        fieldPrefix: '字段',
        unnamed: '未命名',
        fieldName: '字段ID',
        fieldNamePlaceholder: '英文标识，如 user_name',
        fieldLabel: '显示名称',
        fieldLabelPlaceholder: '字段显示的标签，如 用户名',
        fieldType: '字段类型',
        required: '必填项',
        fieldDesc: '字段描述',
        fieldDescPlaceholder: '字段的详细说明（可选）',
        placeholder: '占位提示',
        placeholderPlaceholder: '输入框占位文字',
        defaultValue: '默认值',
        defaultValuePlaceholder: '字段默认填充值',
        options: '可选项',
        optionsPlaceholder: '输入选项内容后按回车，如: 选项A',
        addField: '添加字段',
        assignConfig: '办理人配置',
        assignee: '指定办理人',
        assigneePlaceholder: '输入用户名或ID后按回车',
        assigneeFromVar: '从变量选择办理人',
        assigneeVarPlaceholder: '选择包含办理人名单的变量',
        allowReassign: '允许转办',
        allowReject: '允许驳回/拒绝',
        notifyConfig: '通知配置',
        notifyType: '通知方式',
        emailProvider: '邮件服务商',
        emailProviderPlaceholder: '选择邮件服务商快速配置',
        customConfig: '自定义配置',
        smtpServer: 'SMTP服务器',
        port: '端口',
        isHtml: 'HTML格式',
        username: '用户名',
        usernamePlaceholder: '登录用户名或邮箱',
        password: '密码/授权码',
        passwordPlaceholder: '密码或应用专用密码',
        passwordTip: '部分邮箱需要使用授权码而非登录密码',
        from: '发件人邮箱',
        fromName: '发件人名称',
        subject: '邮件主题',
        notifyTemplate: '通知模板',
        notifyTemplatePlaceholder:
          '支持变量: {{title}}, {{description}}, {{assignees}}',
        timeoutConfig: '超时处理',
        timeoutSeconds: '超时时长(秒)',
        defaultTimeoutTip: '默认无限制，最大30天',
        formStyle: '表单样式',
        layout: '布局方式',
        layouts: {
          vertical: '垂直布局',
          horizontal: '水平布局',
          inline: '行内布局',
        },
        labelWidth: '标签宽度',
        submitText: '提交按钮',
        rejectText: '拒绝按钮',
        cancelText: '取消按钮',
        outputVars: '输出变量',
      },
    },
    trigger: {
      common: {
        config: '触发配置',
        type: '触发类型',
        typePlaceholder: '请选择触发类型',
        advanced: '高级配置',
        enabled: '启用',
      },
      schedule: {
        configHeader: '触发配置',
        timezone: '时区',
        timezonePlaceholder: '请选择时区',
        triggerTime: '触发时间',
        useVisualPicker: '可视化选择',
        useCronExpression: '使用 cron 表达式',
        frequency: '频率',
        frequencyPlaceholder: '请选择频率',
        hourly: '每小时',
        daily: '每天',
        weekly: '每周',
        monthly: '每月',
        onMinute: '分钟',
        onMinutePlaceholder: '分钟 (0-59)',
        time: '时间',
        timePlaceholder: '选择时间',
        weekDays: '星期',
        weekDaysPlaceholder: '选择星期几',
        weekDaySun: '周日',
        weekDayMon: '周一',
        weekDayTue: '周二',
        weekDayWed: '周三',
        weekDayThu: '周四',
        weekDayFri: '周五',
        weekDaySat: '周六',
        monthDays: '日期',
        monthDaysPlaceholder: '选择每月日期',
        lastDay: '最后一天',
        lastDayLabel: '每月最后一天',
        cron: 'Cron 表达式',
        cronPlaceholder: '0 9 * * *',
        cronTip:
          '格式: 分钟 小时 日 月 星期\n示例: 0 9 * * * (每天9点) | */5 * * * * (每5分钟)',
        next5ExecutionTimes: '接下来 5 次执行时间',
        outputVarsHeader: '可引用变量',
        hints: {
          cronRequired: '请输入 cron 表达式以预览执行时间。',
          cronInvalid: 'cron 表达式至少需要 5 段。',
          cronPreview: '输入合法 cron 表达式后可预览未来执行时间。',
          visualPreview: '设置频率和时间后可预览未来执行时间。',
          weekDaysRequired: 'Weekly 模式下至少选择一个星期。',
          monthDaysRequired:
            'Monthly 模式下至少选择一个日期，或勾选每月最后一天。',
        },
      },
      webhook: {
        config: 'Webhook配置',
        webhookUrlPlaceholder: '请输入Webhook URL',
        path: '路径',
        pathPlaceholder: '/webhook/your-path',
        webhookUrl: 'Webhook URL',
        method: 'HTTP方法',
        methodPlaceholder: '请选择HTTP方法',
        testRunUrl: 'Test Run URL',
        publishedUrl: 'Published URL',
        copy: '复制',
        contentType: 'Content Type',
        contentTypes: {
          json: 'application/json',
          formUrlEncoded: 'application/x-www-form-urlencoded',
          plain: 'text/plain',
          octetStream: 'application/octet-stream',
          multipart: 'multipart/form-data',
        },
        queryParameters: 'Query Parameters',
        headerParameters: 'Header Parameters',
        requestBodyParameters: 'Request Body Parameters',
        variableName: '变量名',
        variableNamePlaceholder: '输入变量名',
        authorization: '鉴权',
        authorizationInQuery: 'Authorization in Query Parameters',
        authorizationInHeader: 'Authorization in header parameters',
        authorizationName: '鉴权名称',
        authorizationNamePlaceholder: '输入鉴权名称',
        authorizationValue: '鉴权值',
        authorizationValuePlaceholder: '输入鉴权值',
        value: '值',
        validatePayload: 'Validate payload',
        validatePayloadTooltip:
          '强制严格数据匹配。仅当请求与您配置的 query、header 和 body 参数完全一致时才会被允许触发。',
        outputVars: 'Output Variables',
        addParameter: '添加参数',
      },
    },
    knowledge: {
      noKnowledgeConfigured: '暂无知识库',
      toCreateKnowledge: '去创建知识库',
      knowledgePlaceholder: '请选择知识库',
      create: {
        nameVar: '名称变量',
        nameVarPlaceholder: '请选择名称变量或直接输入固定值',
        descVar: '描述变量',
        descVarPlaceholder: '请选择描述变量或直接输入固定值',
      },
      delete: {
        config: '删除配置',
        docIdVar: '文档ID变量',
        docIdVarPlaceholder: '请选择文档ID变量或直接输入固定值',
      },
      es: {
        kbConfig: '知识库配置',
        kb: '知识库',
        kbPlaceholder: '请选择知识库',
        queryConfig: '查询配置',
        queryVar: '查询变量',
        queryVarPlaceholder: '选择查询变量',
        queryType: '查询类型',
        queryTypePlaceholder: '请选择查询类型',
        queryTypes: {
          match: 'Match (全文匹配)',
          matchPhrase: 'Match Phrase (短语匹配)',
          multiMatch: 'Multi Match (多字段匹配)',
          queryString: 'Query String (查询字符串)',
          bool: 'Bool (布尔查询)',
          custom: 'Custom DSL (自定义)',
        },
        searchFields: '搜索字段',
        searchFieldsPlaceholder: '输入字段名后回车',
        queryDsl: 'Query DSL',
        queryDslPlaceholder: '输入 ElasticSearch Query DSL (JSON格式)',
        pagination: '分页与排序',
        from: '起始位置',
        size: '返回数量',
        sort: '排序配置',
        sortPlaceholder: '输入排序配置 (JSON数组)',
        highlight: '高亮配置',
        enableHighlight: '启用高亮',
        highlightFields: '高亮字段',
        highlightFieldsPlaceholder: '输入要高亮的字段名',
        preTags: '前置标签',
        postTags: '后置标签',
      },
      memory: {
        kbId: '知识库ID',
        kbIdPlaceholder: '请选择知识库ID',
        item: '检索项',
        tableName: '表名',
        tableNamePlaceholder: '请输入表名',
        inputVar: '输入变量',
        inputVarPlaceholder: '请选择输入变量',
        defaultValue: '默认值',
        defaultValuePlaceholder: '请输入默认值',
        outputFormat: '输出格式',
        outputFormatPlaceholder: '请输入输出格式, 例如: npc_{id}',
        outputVar: '输出变量',
        outputVarNamePlaceholder: '请输入输出变量名',
        addItem: '添加检索项',
      },
      document: {
        config: '文档配置',
      },
      search: {
        config: '搜索配置',
        searchType: '搜索类型',
        searchTypePlaceholder: '请选择搜索类型',
        searchTypes: {
          auto: '默认检索',
          bm25: 'bm25检索',
          vector: '向量检索',
          hybrid: '融合检索',
          es_default: 'ES默认',
          es_query: 'ES Query',
        },
        kbIdVar: '知识库ID变量',
        kbIdVarPlaceholder: '请选择知识库ID变量或直接输入固定值',
        topK: '返回数量 TopK',
        scoreThreshold: '分数阈值',
        includeMetadata: '返回是否包含元数据',
        fusionMethod: '融合方法',
        bm25Weight: 'BM25权重',
        vectorWeight: '向量权重',
        rrfConstant: 'RRF常数k',
        rerankTopK: '重排序候选数量',
        diversityBoost: '多样性提升因子',
        normalize: '是否归一化分数',
        rerank: '是否重排序',
        esQueryDsl: 'ES查询语句',
        esQueryDslTooltip: '请输入合法的 JSON 格式 ES 查询语句',
        metaFilter: '元数据过滤配置',
        checkEsQuery: '请检查ES查询语句是否正确',
      },
      upload: {
        config: '上传配置',
        fileContentVar: '文件内容变量',
        fileContentVarPlaceholder: '请选择文件内容变量',
        filenameVar: '文件名变量',
        filenameVarPlaceholder: '请选择文件名变量',
        filePath: '文件路径',
        filePathPlaceholder: '可选：直接输入文件路径',
        saveLocalCopy: '保存本地副本',
        localSavePath: '本地保存路径',
        localSavePathPlaceholder: '可选：本地保存路径',
      },
      vectorize: {
        config: '向量化配置',
        embeddingModel: '嵌入模型',
        embeddingModelPlaceholder: '请输入嵌入模型名称',
        chunkingMethod: '分块方法',
        chunkingMethodPlaceholder: '请输入分块方法',
        chunkSize: '块大小',
        chunkSizePlaceholder: '请输入块大小',
        chunkOverlap: '块重叠',
        chunkOverlapPlaceholder: '请输入块重叠',
      },
    },
    rag: {
      generation: {
        config: '生成配置',
        modelName: '模型名称',
        modelNamePlaceholder: '请输入模型名称',
        promptTemplate: '提示词模板',
        promptTemplatePlaceholder: '请输入提示词模板',
        contextVar: '上下文变量',
        contextVarPlaceholder: '请选择上下文变量',
        queryVar: '查询变量',
        queryVarPlaceholder: '请选择查询变量',
        temperature: '生成温度',
        temperaturePlaceholder: '请输入生成温度',
        maxTokens: '最大Token数',
        maxTokensPlaceholder: '请输入最大Token数',
        systemPrompt: '系统提示词',
        systemPromptPlaceholder: '可选：系统提示词',
        streaming: '流式生成',
      },
      retrieval: {
        config: 'RAG检索配置',
        kbIdPlaceholder: '请选择知识库ID或者直接输入固定值',
        outputFormats: {
          raw: '原始(raw)',
          formatted: '格式化(formatted)',
          combined: '合并(combined)',
        },
      },
    },
    code: {
      common: {
        config: '代码',
        generateTemplate: '生成模板',
        timeout: '超时时间',
        timeoutPlaceholder: '执行超时时间（秒）',
        unitSecond: '秒',
        varSelectTip: '💡 输入 $ 符号可快速选择前置节点变量',
        template: {
          todo: '在这里编写你的处理逻辑',
        },
      },
      javascript: {
        availableApi: '可用 API',
        input: '输入',
        output: '输出',
        helper: '辅助函数',
        template: {
          getInput: '获取输入变量',
          processing: '处理逻辑',
          returnResult: '返回结果',
        },
      },
      python: {
        funcTemplate: '函数模板',
        requirements: '依赖包',
        requirementsPlaceholder: '请输入依赖包列表，按Enter键添加',
        template: {
          inputParams: '输入参数',
          returnValue: '返回值',
          none: '无',
        },
      },
    },
    nodeTypes: {
      categories: {
        ai: 'AI 节点',
        byte_house: 'ByteHouse',
        code: '代码节点',
        data: '数据节点',
        database: '数据库节点',
        flow: '流程控制',
        io: '输入输出',
        knowledge: '知识库',
        milvus: 'Milvus',
        mysql: 'MySQL',
        postgres: 'PostgreSQL',
        rag: 'RAG 节点',
        redis: 'Redis',
        sqlite: 'SQLite',
        trigger: '触发器',
      },
      data: {
        names: {
          document_extractor: '文档提取节点',
          list_operator: '列表操作节点',
          template: '模板节点',
          transform: '数据转换节点',
          set: '变量设置节点',
        },
        descriptions: {
          document_extractor: '从各种格式的文档中提取文本内容',
          list_operator: '对列表数据进行过滤、排序、去重、映射等操作',
          template: '使用模板引擎渲染动态内容',
          transform: '提供编码、格式转换、哈希、加密等数据转换功能',
          set: '设置工作流变量',
        },
        labels: {
          document_extractor: {
            source: '数据来源',
            type: '文档类型',
            input_var: '输入变量',
            ocr_enabled: '启用OCR',
            extract_images: '提取图片',
            extract_metadata: '提取元数据',
            output_vars: '输出变量',
          },
          list_operator: {
            operation: '操作类型',
            input_var: '输入变量',
            field: '字段',
            conditions: '条件',
            output_vars: '输出变量',
          },
          template: {
            engine: '模板引擎',
            template: '模板内容',
            variables: '变量',
            output_format: '输出格式',
            output_vars: '输出变量',
          },
          transform: {
            type: '转换类型',
            input_var: '输入变量',
            output_vars: '输出变量',
          },
          set: {
            values: '变量值',
            mode: '设置模式',
            output_vars: '输出变量',
          },
        },
      },
      ai: {
        names: {
          llm: 'LLM 节点',
          embedding: '嵌入节点',
          tokenizer: '分词节点',
          intent: '意图识别',
          content_safe: '大模型内容安全检测',
          agent: 'Agent 智能体节点',
          image_to_text: '图像理解',
          text_to_image: '图像生成',
          tts: '文字转语音',
          stt: '语音转文字',
          voice_clone: '声音克隆',
          video_parser: '视频解析',
          video_generation: '视频生成',
          gen_3d: '3D 模型生成',
        },
        descriptions: {
          llm: '调用大语言模型进行文本生成',
          embedding: '将文本转换为向量表示',
          tokenizer: '对文本进行分词处理',
          intent: '用于用户输入的意图识别，并将其与预设意图选项进行匹配',
          content_safe: '检测大模型输入输出文本内容风险',
          agent: '支持多种推理策略的智能 Agent，可进行复杂任务推理',
          image_to_text: '图像理解视觉 AI 能力',
          text_to_image:
            '使用 AI 生成图像，支持 DALL-E、Stable Diffusion 等模型',
          tts: '将文本转换为语音，支持多种音色和语言',
          stt: '将语音转换为文本，支持多种语言和格式',
          voice_clone: '克隆声音或使用克隆的声音合成语音',
          video_parser: '视频理解、摘要、转录、物体检测等能力',
          video_generation: '支持文本或图片生成视频',
          gen_3d: '根据图片或文本描述生成 3D 模型。当前仅支持火山引擎。',
        },
        labels: {
          llm: {
            model_name: '模型名称',
            prompt: '提示词',
            temperature: '生成温度',
            max_tokens: '最大令牌数',
            streaming: '是否流式生成',
            system_prompt: '系统提示词',
            output_vars: '输出变量',
            prompt_vars: '提示词变量',
          },
          embedding: {
            input_vars: '输入变量',
            model_name: '模型名称',
            batch_size: '批次大小',
            output_vars: '输出变量',
          },
          tokenizer: {
            input_vars: '输入变量',
            model: '分词模型',
            mode: '分词模式',
            output_vars: '输出变量',
          },
          agent: {
            strategy: '推理策略',
            task: '任务描述',
            system_prompt: '系统提示词',
            max_iterations: '最大迭代次数',
            temperature: '生成温度',
            timeout: '超时时间',
            max_tokens: '最大令牌数',
            tools: '可用工具',
            strategy_params: '策略参数',
            input_vars: '输入变量',
            output_vars: '输出变量',
          },
        },
      },
      code: {
        names: {
          javascript: 'JavaScript 节点',
          python: 'Python 节点',
        },
        descriptions: {
          javascript: '执行 JavaScript 代码',
          python: '执行 Python 代码',
        },
        labels: {
          javascript: {
            code: 'JavaScript 代码',
            input_varss: '输入变量',
            output_vars: '输出变量',
          },
          python: {
            input_varss: '输入变量',
            code: 'Python 代码',
            python_path: 'Python 路径',
            requirements: '依赖包',
            output_vars: '输出变量',
          },
        },
      },
      database: {
        names: {
          mysql: 'MySQL 节点',
          redis: 'Redis 节点',
          sqlite: 'SQLite 节点',
          byte_house: 'ByteHouse 节点',
          postgres: 'PostgreSQL 节点',
          milvus: 'Milvus 节点',
        },
        descriptions: {
          mysql: '执行 MySQL 数据库操作',
          redis: '执行 Redis 缓存操作',
          sqlite: '执行 SQLite 数据库操作',
          byte_house: '执行 ByteHouse 数据库操作',
          postgres: '执行 PostgreSQL 向量数据库操作(pgvector)',
          milvus: '执行 Milvus 向量数据库操作',
        },
        labels: {
          mysql: {
            operation: '操作类型',
            table: '表名',
            condition: '条件',
            data: '数据',
            sql: 'SQL 语句',
            connection: '连接配置',
            max_results: '最大结果数',
            output_vars: '输出变量',
          },
          redis: {
            operation: '操作类型',
            key: '键',
            value: '值',
            field: '字段',
            expiration: '过期时间',
            connection: '连接配置',
            output_vars: '输出变量',
          },
          postgres: {
            operation: '操作类型',
            table_name: '表名',
            column_name: '列名',
            data: '数据',
            query_vector: '查询向量',
            query_vector_var: '查询向量变量',
            limit: '限制数量',
            index_type: '索引类型',
            index_params: '索引参数',
            connection: '连接配置',
            output_vars: '输出变量',
          },
          milvus: {
            operation: '操作类型',
            collection: '集合名',
            partition: '分区名',
            data: '数据',
            vector_field: '向量字段',
            index_params: '索引参数',
            search_params: '搜索参数',
            expression: '表达式',
            connection: '连接配置',
            output_vars: '输出变量',
          },
        },
      },
      flow: {
        names: {
          conditional: '条件节点',
          loop: '循环节点',
          aggregator: '聚合节点',
          subworkflow: '子工作流节点',
          stream_wait: '流式等待节点',
          wait: '等待节点',
          human_input: '人工输入节点',
        },
        descriptions: {
          conditional: '根据条件执行不同分支',
          loop: '执行循环操作',
          aggregator: '聚合多个数据源',
          subworkflow: '可复用现有工作流',
          stream_wait: '等待流式输出完成后再继续执行',
          wait: '暂停工作流执行，支持定时、回调、事件、审批等待',
          human_input: '暂停工作流等待人工填写表单数据',
        },
        labels: {
          conditional: {
            condition: '条件表达式',
            true_node_id: '真分支节点 ID',
            false_node_id: '假分支节点 ID',
            condition_vars: '条件变量',
          },
          loop: {
            loop_type: '循环类型',
            count_value: '计数值',
            count_var: '计数变量',
            condition: '条件',
            condition_vars: '条件变量',
            loop_node_id: '循环体节点 ID',
            exit_node_id: '退出节点 ID',
            max_iterations: '最大迭代次数',
            allow_infinite_loop: '是否允许无限循环',
          },
          parallel: {
            branch_node_ids: '分支节点 ID 列表',
            join_node_id: '汇合节点 ID',
            wait_for_all: '等待所有分支',
            timeout_seconds: '超时秒数',
            result_var: '结果变量',
          },
          aggregator: {
            source_vars: '源变量列表',
            separator: '分隔符',
            output_format: '输出类型',
            output_vars: '输出变量',
          },
        },
      },
      io: {
        names: {
          http_input: 'HTTP 输入节点',
          http_output: 'HTTP 输出节点',
          tcp_input: 'Websocket 输入节点',
          tcp_output: 'Websocket 输出节点',
          token: 'Token 节点',
          message: '消息通知节点',
          cloud_storage: '云盘操作节点',
          file: '文件操作节点',
          web_search: '联网搜索节点',
        },
        descriptions: {
          http_input: '接收 HTTP 请求',
          http_output: '发送 HTTP 响应',
          tcp_input: '接收 Websocket 消息',
          tcp_output: '发送 Websocket 消息',
          token: '生成或验证 Token',
          message: '发送消息通知，支持邮件、钉钉、飞书、企业微信、Slack 等渠道',
          cloud_storage:
            '支持阿里云盘、百度网盘、Google Drive、OneDrive、S3 等云存储操作',
          file: '读取、写入、复制、移动、删除文件',
          web_search: '使用搜索引擎搜索互联网内容',
        },
        labels: {
          http_input: {
            path: '路径',
            method: 'HTTP 方法',
            required_params: '必需参数',
            headers: '请求头',
            auth_required: '是否需要认证',
            output_vars: '输出变量',
          },
          http_output: {
            status_code: '状态码',
            headers: '响应头',
            content_var: '内容变量',
            format_json: '格式化 JSON',
          },
          tcp_input: {
            protocol: '执行标识',
            output_vars: '输出变量',
          },
          tcp_output: {
            protocol: '执行标识',
            content_var: '内容变量',
            format_json: '格式化 JSON',
            streaming: '流式传输',
          },
          token: {
            mode: 'Token 操作',
            input_vars: '输入变量',
            output_vars: '输出变量',
          },
        },
      },
      knowledge: {
        names: {
          kb_search: '知识库检索节点',
          kb_memory: '知识库内存检索节点',
          kb_es: 'ElasticSearch 检索节点',
          knit_kb_search: '知识库搜索节点',
          knit_kb_doc_create: '知识库文档创建节点',
        },
        descriptions: {
          kb_search: '在知识库中检索相关内容',
          kb_memory: '从知识库内存中检索相关内容',
          kb_es: '使用 ElasticSearch 进行全文检索',
          knit_kb_search: '在知识库中检索相关内容',
          knit_kb_doc_create: '在知识库中创建文档',
        },
        labels: {
          kb_create: {
            name: '知识库名称',
            description: '知识库描述',
            name_var: '名称变量',
            desc_var: '描述变量',
            output_vars: '输出变量',
          },
          kb_upload: {
            knowledge_base_id: '知识库 ID',
            knowledge_base_id_var: '知识库 ID 变量',
            file_content_var: '文件内容变量',
            filename_var: '文件名变量',
            file_path: '文件路径',
            save_local_copy: '保存本地副本',
            local_save_path: '本地保存路径',
            output_vars: '输出变量',
          },
          kb_search: {
            knowledge_base_id: '知识库 ID',
            knowledge_base_id_var: '知识库 ID 变量',
            query_var: '查询变量',
            model_name: '模型名称',
            top_k: '返回数量',
            score_threshold: '分数阈值',
            output_vars: '输出变量',
            max_results: '最大结果数',
            include_metadata: '包含元数据',
          },
          kb_vectorize: {
            document_ids: '文档 ID 列表',
            document_ids_var: '文档 ID 变量',
            embedding_model: '嵌入模型',
            chunking_method: '分块方法',
            chunk_size: '块大小',
            chunk_overlap: '块重叠',
            vector_db_config: '向量数据库配置',
            output_vars: '输出变量',
          },
          kb_delete: {
            document_id: '文档 ID',
            document_ids_var: '文档 ID 变量',
            output_vars: '输出变量',
          },
          knit_kb_search: {
            config_uuid: '配置 UUID',
            config_type: '配置类型',
            query_var: '查询变量',
            page: '页码',
            page_size: '每页数量',
            similarity_threshold: '相似度阈值',
            score_threshold: '分数阈值',
            vector_similarity_weight: '向量相似度权重',
            top_k: '返回数量',
            rerank_id: '重排序 ID',
            keyword: '关键词检索',
            highlight: '高亮',
            metadata_condition_json: '元数据条件 JSON',
            document_ids: '文档 ID 列表',
            cross_languages: '跨语言',
            output_vars: '输出变量',
          },
          knit_kb_doc_create: {
            knowledge: '知识库',
            content_var: '文本内容变量',
            file_data_var: '文件数据变量',
            file_name_var: '文件名变量',
            file_name: '文件名',
            parent_path: '父级路径',
            output_vars: '输出变量',
          },
        },
      },
      rag: {
        labels: {
          retrieval: {
            knowledge_base_id: '知识库 ID',
            knowledge_base_id_var: '知识库 ID 变量',
            query_var: '查询变量',
            embedding_model: '嵌入模型',
            top_k: '返回数量',
            output_vars: '输出变量',
            output_format: '输出格式',
          },
          generation: {
            model_name: '模型名称',
            prompt_template: '提示词模板',
            context_var: '上下文变量',
            query_var: '查询变量',
            temperature: '生成温度',
            max_tokens: '最大令牌数',
            system_prompt: '系统提示词',
            streaming: '流式生成',
            output_vars: '输出变量',
          },
        },
      },
      trigger: {
        names: {
          schedule_trigger: '定时触发器',
          webhook_trigger: 'Webhook 触发器',
        },
        descriptions: {
          schedule_trigger: '基于 Cron 表达式或固定间隔定时触发工作流',
          webhook_trigger: '通过 HTTP Webhook 触发工作流',
        },
        labels: {
          schedule_trigger: {
            timezone: '时区',
            schedule_mode: '调度方式',
            cron: 'Cron 表达式',
            frequency: '频率',
            output_vars: '输出变量',
          },
          webhook_trigger: {
            path: 'Webhook 路径',
            method: 'HTTP 方法',
            content_type: 'Content Type',
            query_parameters: 'Query Parameters',
            header_parameters: 'Header Parameters',
            request_body_parameters: 'Request Body Parameters',
            validate_payload: 'Validate Payload',
            output_vars: '输出变量',
          },
        },
      },
    },
    workflowGraph: {
      messages: {
        nodeLocked: '用户 {nickname} 正在编辑此节点，请稍后再试',
        layoutFailed: '布局优化失败，请稍后重试',
        applyAIFailed: '应用工作流失败',
      },
      nodeFallback: '节点',
      copySuffix: '_副本',
    },
    workflow: {
      status: {
        success: '完成',
        completed: '完成',
        failed: '失败',
        error: '失败',
        ready: '已准备',
        waiting: '等待中',
        running: '运行中',
        skipped: '跳过',
      },
    },
  },
};
